import { render, staticRenderFns } from "./TicketShares.vue?vue&type=template&id=2a4bc4fb&"
import script from "./TicketShares.vue?vue&type=script&lang=js&"
export * from "./TicketShares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports